export default {
    inputAppName: 'Please input App Name',
    noResult: 'There\'s no result with "{keyword}"'
};
